<template>
    <div class="form__group form__group--number">
        <button @click="decreaseValue" :class="['btn btn--option', {'disabled': inputValue == 1}]">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="14" width="19.5" height="3" rx="1.5" fill="#844649"/>
            </svg>
        </button>
        <div :class="['input input--number', {'max': inputValue == maxValue}]">{{ inputValue }}</div>
        <button @click="increaseValue" :class="['btn btn--option', {'disabled': inputValue == maxValue}]">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.196 17.1952L24.4783 17.2032C24.7976 17.2032 25.1038 17.0763 25.3296 16.8505C25.5554 16.6248 25.6822 16.3186 25.6822 15.9993C25.6823 15.68 25.5555 15.3738 25.3297 15.1481C25.104 14.9223 24.7978 14.7955 24.4785 14.7955L17.1962 14.8045L17.2052 7.5222C17.2052 7.20292 17.0784 6.89673 16.8526 6.67098C16.6269 6.44524 16.3207 6.31843 16.0014 6.31845C15.6821 6.31847 15.3759 6.44533 15.1501 6.6711C14.9244 6.89688 14.7975 7.20309 14.7975 7.52237L14.8055 14.8047L7.52312 14.7967C7.36485 14.7961 7.20801 14.8268 7.06166 14.8871C6.9153 14.9474 6.78233 15.036 6.67041 15.148C6.55848 15.2599 6.46983 15.3928 6.40955 15.5392C6.34927 15.6856 6.31856 15.8424 6.3192 16.0007C6.31854 16.1589 6.34922 16.3158 6.40948 16.4621C6.46974 16.6085 6.55838 16.7414 6.67029 16.8533C6.78219 16.9652 6.91515 17.0539 7.0615 17.1141C7.20784 17.1744 7.36468 17.2051 7.52295 17.2044L14.8053 17.1954L14.7963 24.4778C14.7956 24.636 14.8263 24.7929 14.8866 24.9392C14.9468 25.0855 15.0355 25.2185 15.1474 25.3304C15.2593 25.4423 15.3922 25.531 15.5386 25.5912C15.6849 25.6515 15.8418 25.6822 16 25.6815C16.1583 25.6821 16.3151 25.6514 16.4615 25.5912C16.6078 25.5309 16.7408 25.4422 16.8527 25.3303C16.9647 25.2184 17.0533 25.0854 17.1136 24.939C17.1739 24.7927 17.2046 24.6359 17.204 24.4776L17.196 17.1952Z" fill="#844649"/>
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    name: 'NumberInput',
    props: ['options'],
    data() {
        return {
            inputValue: 1
        }
    },
    computed: {
        maxValue() {
            return this.options.gameOptions[0].maxValue;
        },
        updatingOption() {
            return this.$store.getters['game/getIsUpadtingOption'];
        },
        savedOptions() {
            return this.$store.getters['game/getSavedOptions'];
        }
    },
    methods: {
        increaseValue() {
            if (this.inputValue < this.maxValue) {
                this.inputValue = this.inputValue + 1;
            }
        },
        decreaseValue() {
            if (this.inputValue > 1) {
                this.inputValue = this.inputValue - 1;
            }
        },
        checkSavedValue() {
            const savedOption = this.savedOptions.filter(option => option.id == this.options.id);

            if (this.updatingOption && savedOption.length) {
                this.inputValue = parseInt(savedOption[0].data.value);
            }
        }
    },
    mounted() {
        this.checkSavedValue();
    }
}
</script>
